import { FlameIcon } from 'lucide-react';
import type { Snap } from '@/types/database.types';
import BaseSnapCard from './BaseSnapCard';

interface SystemSnapCardProps {
  snap: Snap & { activity: 'hot' | 'trending' | null };
  onDelete: (id: string) => void;
  onLike: (id: string, event: React.MouseEvent) => void;
  onVote?: (snapId: string, optionId: string) => void;
  onRemoveVote?: (snapId: string) => void;
  isVoting?: boolean;
}

export default function SystemSnapCard({ snap, onDelete, onLike, onVote, onRemoveVote, isVoting }: SystemSnapCardProps) {
  return (
    <>
      <style>
        {`
          @keyframes firesnap-glow {
            0% { background-position: 0% 50%; }
            100% { background-position: 200% 50%; }
          }
          .firesnap-glow::before {
            content: '';
            position: absolute;
            top: -4px;
            left: 0;
            width: 100%;
            height: 6px;
            background: linear-gradient(90deg,
              #ff0000, #ff6600, #ffcc00, #ffff66, #ffcc00, #ff6600, #ff0000);
            background-size: 200% 100%;
            box-shadow: 0 0 25px rgba(255, 80, 0, 0.8), 0 0 30px rgba(255, 150, 0, 0.7);
            border-radius: 12px 12px 0 0;
            animation: firesnap-glow 2.5s linear infinite;
            filter: blur(4px);
            opacity: 0.95;
          }
        `}
      </style>
      <BaseSnapCard
        snap={snap}
        onDelete={onDelete}
        onLike={onLike}
        onVote={onVote}
        onRemoveVote={onRemoveVote}
        isVoting={isVoting}
        wrapperClassName="bg-gradient-to-br from-orange-50 to-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 overflow-hidden cursor-pointer relative border-2 border-orange-200 firesnap-glow h-full flex flex-col"
        badges={
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
            <FlameIcon className="h-3.5 w-3.5 mr-1" />
            FIRESNAP
          </span>
        }
      />
    </>
  );
}